// ABOUTME: Class strings shared by the auth screens — footer links and method-section labels.
// ABOUTME: One place per rule so every /auth screen renders them identically (docs/DESIGN_SYSTEM.md §4.2).

/** Link under the card's hairline rule, and any link that reads as one. */
export const AUTH_LINK_CLASS = "text-sm font-medium text-primary hover:text-primary-700 hover:underline"

/**
 * Heading of a section inside the card — "Sign in with a one-time code".
 *
 * 15/600 in the foreground colour, never uppercase: the design reserves the 12px uppercase
 * treatment for the super-heading ABOVE a group of cards, and a section inside one reads as a
 * heading, not a label (docs/design/Вход.dc.html, docs/design/Дизайн-система.dc.html §06).
 * SettingsCard renders its own title the same way.
 */
export const SECTION_LABEL_CLASS = "text-[15px] font-semibold text-foreground"
